import { render, staticRenderFns } from "./template.vue?vue&type=template&id=9525cbca&scoped=true&"
import script from "@/Components/Global/BasicHeader/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/BasicHeader/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/BasicHeader/style.scss?vue&type=style&index=0&id=9525cbca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9525cbca",
  null
  
)

export default component.exports